import { CALL_API, Schemas } from '../../common/middleware/api';

export const INDIVIDUAL_CONSULTATION_DOCUMENTS_REQUEST = 'INDIVIDUAL_CONSULTATION_DOCUMENTS_REQUEST';
export const INDIVIDUAL_CONSULTATION_DOCUMENTS_SUCCESS = 'INDIVIDUAL_CONSULTATION_DOCUMENTS_SUCCESS';
export const INDIVIDUAL_CONSULTATION_DOCUMENTS_FAILURE = 'INDIVIDUAL_CONSULTATION_DOCUMENTS_FAILURE';

export const INDIVIDUAL_CONSULTATION_DOCUMENT_FETCH_REQUEST = 'INDIVIDUAL_CONSULTATION_DOCUMENT_GET_REQUEST';
export const INDIVIDUAL_CONSULTATION_DOCUMENT_FETCH_SUCCESS = 'INDIVIDUAL_CONSULTATION_DOCUMENT_GET_SUCCESS';
export const INDIVIDUAL_CONSULTATION_DOCUMENT_FETCH_FAILURE = 'INDIVIDUAL_CONSULTATION_DOCUMENT_GET_FAILURE';

export const INDIVIDUAL_CONSULTATION_DOCUMENT_CREATE_REQUEST = 'INDIVIDUAL_CONSULTATION_DOCUMENT_CREATE_REQUEST';
export const INDIVIDUAL_CONSULTATION_DOCUMENT_CREATE_SUCCESS = 'INDIVIDUAL_CONSULTATION_DOCUMENT_CREATE_SUCCESS';
export const INDIVIDUAL_CONSULTATION_DOCUMENT_CREATE_FAILURE = 'INDIVIDUAL_CONSULTATION_DOCUMENT_CREATE_FAILURE';

export const INDIVIDUAL_CONSULTATION_DOCUMENT_UPDATE_REQUEST = 'INDIVIDUAL_CONSULTATION_DOCUMENT_UPDATE_REQUEST';
export const INDIVIDUAL_CONSULTATION_DOCUMENT_UPDATE_SUCCESS = 'INDIVIDUAL_CONSULTATION_DOCUMENT_UPDATE_SUCCESS';
export const INDIVIDUAL_CONSULTATION_DOCUMENT_UPDATE_FAILURE = 'INDIVIDUAL_CONSULTATION_DOCUMENT_UPDATE_FAILURE';

export const INDIVIDUAL_CONSULTATION_DOCUMENT_DELETE_REQUEST = 'INDIVIDUAL_CONSULTATION_DOCUMENT_DELETE_REQUEST';
export const INDIVIDUAL_CONSULTATION_DOCUMENT_DELETE_SUCCESS = 'INDIVIDUAL_CONSULTATION_DOCUMENT_DELETE_SUCCESS';
export const INDIVIDUAL_CONSULTATION_DOCUMENT_DELETE_FAILURE = 'INDIVIDUAL_CONSULTATION_DOCUMENT_DELETE_FAILURE';

export const loadIndividualConsultationDocuments = ({ paymentId, ...options }) => ({
	[CALL_API]: {
		types: [INDIVIDUAL_CONSULTATION_DOCUMENTS_REQUEST, INDIVIDUAL_CONSULTATION_DOCUMENTS_SUCCESS, INDIVIDUAL_CONSULTATION_DOCUMENTS_FAILURE],
		endpoint: 'api/individualConsultationDocuments',
		request: { paymentId, ...options },
		schema: Schemas.INDIVIDUAL_CONSULTATION_DOCUMENT_ARRAY
	},
	paymentId
});

export const createIndividualConsultationDocument = (individualConsultationDocument, history) => ({
	[CALL_API]: {
		types: [INDIVIDUAL_CONSULTATION_DOCUMENT_CREATE_REQUEST, INDIVIDUAL_CONSULTATION_DOCUMENT_CREATE_SUCCESS, INDIVIDUAL_CONSULTATION_DOCUMENT_CREATE_FAILURE],
		endpoint: 'api/individualConsultationDocuments',
		method: 'POST',
		request: individualConsultationDocument,
		schema: Schemas.INDIVIDUAL_CONSULTATION_DOCUMENT,
		form: 'individualConsultationDocument',
		transition: {
			history,
			successPath: (response) => {
				//const { id, paymentId } = response.entities.individualConsultationDocuments[response.result];
				return `./`;	// return to list (cannot edit individual consultation documents)
			}
		}
	}
});

export const updateIndividualConsultationDocument = (id, individualConsultationDocument) => ({
	[CALL_API]: {
		types: [INDIVIDUAL_CONSULTATION_DOCUMENT_UPDATE_REQUEST, INDIVIDUAL_CONSULTATION_DOCUMENT_UPDATE_SUCCESS, INDIVIDUAL_CONSULTATION_DOCUMENT_UPDATE_FAILURE],
		endpoint: `api/individualConsultationDocuments/${id}`,
		method: 'PUT',
		request: individualConsultationDocument,
		schema: Schemas.INDIVIDUAL_CONSULTATION_DOCUMENT,
		form: 'individualConsultationDocument'
	}
});

export const deleteIndividualConsultationDocument = (id, onSuccess) => ({
	[CALL_API]: {
		types: [INDIVIDUAL_CONSULTATION_DOCUMENT_DELETE_REQUEST, INDIVIDUAL_CONSULTATION_DOCUMENT_DELETE_SUCCESS, INDIVIDUAL_CONSULTATION_DOCUMENT_DELETE_FAILURE],
		endpoint: `api/individualConsultationDocuments/${id}`,
		method: 'DELETE',
		schema: Schemas.INDIVIDUAL_CONSULTATION_DOCUMENT,
		onSuccessEvent: onSuccess
	}
});